import { useDynamicConfig } from "@statsig/react-bindings";

import { AI_ASSISTANT_CONSTANTS } from "../constants/aiAssistantConstants";

/**
 * Release number for the version badge, set in Statsig's `Lou_configurations`
 * dynamic config as `{ "version": "1.7.0" }`.
 *
 * The UI keeps no version of its own, so with no value there - Statsig not yet
 * initialised, or the key missing - the badge simply does not render.
 */
export const useLouVersion = (): string | null => {
  const config = useDynamicConfig(AI_ASSISTANT_CONSTANTS.DYNAMIC_CONFIGS.LOU_CONFIGURATIONS);
  const version = config.get("version", "");
  return typeof version === "string" && version.trim() ? version.trim() : null;
};

export default useLouVersion;
